<template>
  <div v-if="validated">
    <slot />
  </div>
  <div
    v-else
    class="relative rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
    role="alert">
    <strong class="font-bold">Invalid Domain</strong>
    <span class="block sm:inline">
      - {{ hostname }} is not authorized to access DDHQ election data</span
    >
  </div>
</template>

<script>
import ErrorDialogue from "./ErrorDialogue";

const components = {
  ErrorDialogue,
};

const props = {
  allowedDomains: {
    type: Array,
    required: false,
    default: () => [],
  },
};

const bannedDomains = ["truthpuke.com"];

const computed = {
  hostname() {
    return window.location.hostname;
  },
  validated() {
    if (bannedDomains.filter((d) => this.hostname.match(d)).length > 0) {
      return false;
    }

    if (
      this.allowedDomains.includes("universal_embed") ||
      this.allowedDomains.includes("thehill.com")
    ) {
      return true;
    }

    if (process.env.NODE_ENV === "development") return true;

    return this.allowedDomains.filter((d) => this.hostname.match(d)).length > 0;
  },
};

export default {
  components,
  props,
  computed,
};
</script>
